import { cn } from '@/lib/utils';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

const userIconVariants = cva(
  'flex justify-center items-center rounded-full text-white bg-black',
  {
    variants: {
      size: {
        big: 'size-10 text-lg',
        medium: 'size-8 text-base',
        small: 'size-5 text-xs',
      },
    },
    defaultVariants: {
      size: 'big',
    },
  }
);

export interface UserIconProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof userIconVariants> {
  initial: string;
  className?: string;
}
export const UserIcon = ({ size, initial, className }: UserIconProps) => {
  return (
    <div className={cn(userIconVariants({ size, className }))}>
      <span className="font-nunito700">{initial}</span>
    </div>
  );
};
